/**
 * Parse PBN (Portable Bridge Notation) files
 */

export function parsePBN(pbnText) {
  const lines = pbnText.split('\n').map(line => line.trim()).filter(line => line);
  const hands = {};
  
  let currentBoard = null;
  let currentHand = {};
  let inOptimumTable = false;
  let optimumTableData = {};
  
  for (const line of lines) {
    // Board number
    if (line.startsWith('[Board ')) {
      const match = line.match(/\[Board "(\d+)"\]/);
      if (match) {
        if (currentBoard && Object.keys(currentHand).length > 0) {
          // Save previous board with DD data if available
          if (Object.keys(optimumTableData).length > 0) {
            currentHand.ddData = optimumTableData;
          }
          hands[currentBoard] = currentHand;
        }
        currentBoard = match[1];
        currentHand = {};
        optimumTableData = {};
        inOptimumTable = false;
      }
    }
    
    // Dealer
    if (line.startsWith('[Dealer ')) {
      const match = line.match(/\[Dealer "([NESW])"\]/);
      if (match) currentHand.dealer = match[1];
    }
    
    // Vulnerability
    if (line.startsWith('[Vulnerable ')) {
      const match = line.match(/\[Vulnerable "([^"]+)"\]/);
      if (match) currentHand.vulnerable = match[1];
    }
    
    // Deal (most important)
    if (line.startsWith('[Deal ')) {
      const match = line.match(/\[Deal "([NESW]):([^"]+)"\]/);
      if (match) {
        const firstHand = match[1];
        const handsStr = match[2];
        currentHand.deal = parseDeal(firstHand, handsStr);
      }
    }
    
    // Double Dummy Tricks (compact format) - alternative format
    if (line.startsWith('[DoubleDummyTricks ')) {
      const match = line.match(/\[DoubleDummyTricks "([^"]+)"\]/);
      if (match) {
        currentHand.ddCompact = match[1];
      }
    }
    
    // OptimumResultTable - preferred format
    if (line.startsWith('[OptimumResultTable ')) {
      inOptimumTable = true;
      continue;
    }
    
    // Parse OptimumResultTable data
    if (inOptimumTable && !line.startsWith('[')) {
      if (line === '') {
        inOptimumTable = false;
      } else {
        // Format: "N NT 10" or "N  S  9"
        const parts = line.split(/\s+/).filter(p => p);
        if (parts.length === 3) {
          const declarer = parts[0];
          const strain = parts[1];
          const tricks = parseInt(parts[2]);
          
          if (!optimumTableData[declarer]) {
            optimumTableData[declarer] = {};
          }
          optimumTableData[declarer][strain] = tricks;
        }
      }
    }
  }
  
  // Add last board
  if (currentBoard && Object.keys(currentHand).length > 0) {
    if (Object.keys(optimumTableData).length > 0) {
      currentHand.ddData = optimumTableData;
    }
    hands[currentBoard] = currentHand;
  }
  
  return hands;
}

function parseDeal(firstHand, handsStr) {
  const handOrder = ['S', 'W', 'N', 'E'];
  const startIdx = handOrder.indexOf(firstHand);
  const orderedHands = [
    ...handOrder.slice(startIdx),
    ...handOrder.slice(0, startIdx)
  ];
  
  const handStrings = handsStr.split(' ');
  const deal = {};
  
  handStrings.forEach((handStr, idx) => {
    const position = orderedHands[idx];
    const suits = handStr.split('.');
    
    deal[position] = {
      spades: suits[0] || '',
      hearts: suits[1] || '',
      diamonds: suits[2] || '',
      clubs: suits[3] || '',
    };
  });
  
  return deal;
}

export function getVulnerability(vulnStr, position) {
  if (vulnStr === 'None') return false;
  if (vulnStr === 'All') return true;
  if (vulnStr === 'NS' && (position === 'N' || position === 'S')) return true;
  if (vulnStr === 'EW' && (position === 'E' || position === 'W')) return true;
  return false;
}
